export default __webpack_public_path__ + "static/media/reroll_alone.5afb8798.png";